export default [{
        path: '/visitPlan',
        name: 'visitPlan',
        component: () =>
            import ('@/components/page/visitPlan/visitPlanList'),
        meta: { title: '年度拜访计划' } //年度拜访计划
    },
    {
        path: '/visitPlan-add',
        name: 'visitPlanAdd',
        component: () =>
            import ('@/components/page/visitPlan/visitPlanAdd'),
        meta: { title: '年度拜访计划' } //拜访计划-新增
    },
    {
        path: '/visitReport',
        name: 'visitReportList',
        component: () =>
            import ('@/components/page/visitPlan/visitReport'),
        meta: { title: '拜访报告' } //拜访报告
    },
    {
        path: '/visitReport-add',
        name: 'visitReport',
        component: () =>
            import ('@/components/page/visitPlan/visitReportAdd'),
        meta: { title: '拜访报告' } //新增拜访报告
    },
    {
        path: '/visitReportSp',
        name: 'visitReportSp',
        component: () =>
            import ('@/components/page/visitPlan-sp/visitReport'),
        meta: { title: '拜访报告' } //拜访报告sp
    },
    {
        path: '/visitReportSp-detail',
        name: 'visitReportSpDetail',
        component: () =>
            import ('@/components/page/visitPlan-sp/visitReportAdd'),
        meta: { title: '拜访报告' } //年度拜访报告
    },
    {
        path: '/visitReportAudit',
        component: () =>
            import ('@/components/page/visitPlan/visitReportAudit'),
        meta: { title: '拜访报告审批' } //年度拜访报告
    },
]